import { render, staticRenderFns } from "./CreateInclusionGround.vue?vue&type=template&id=52f3447a&"
import script from "./CreateInclusionGround.vue?vue&type=script&lang=js&"
export * from "./CreateInclusionGround.vue?vue&type=script&lang=js&"
import style0 from "./CreateInclusionGround.vue?vue&type=style&index=0&id=52f3447a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports